import { combineReducers } from "@reduxjs/toolkit";
import { History } from "history";
import { connectRouter } from "connected-react-router";
import {
    colorSlice,
    layoutSlice,
    editObserverSlice,
    userAccountSlice,
    accessSlice,
} from "./features";
import profileSlice from "./features/profileSlice";
import ProfileAuthorizationSlice from "./features/ProfileAuthorizationSlice";


const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        colorSlice,
        layoutSlice,
        editObserverSlice,
        userAccountSlice,
        accessSlice,
        profileSlice,
        ProfileAuthorizationSlice
    });

export default createRootReducer;
